exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Top-module__wrapper___3Ph7Z{display:grid;grid-template-columns:auto auto}.Top-module__wrapper___3Ph7Z .Top-module__user___3RzLU{padding:1.25rem 1.5rem 1.5rem;justify-content:start}.Top-module__wrapper___3Ph7Z .Top-module__right-buttons___36wto{display:grid;grid-auto-flow:column;gap:.5rem;margin-top:1.25rem;justify-content:end;margin-right:1.25rem}", ""]);

// exports
exports.locals = {
	"wrapper": "Top-module__wrapper___3Ph7Z",
	"user": "Top-module__user___3RzLU",
	"right-buttons": "Top-module__right-buttons___36wto"
};